export const EMPTY_PENDING_ACTIONS = {
  status: null,
  tagIds: [],
  priority: null,
  teamId: null,
  agentId: null,
};
